import { Button, Flex, Form, Popup, Spacing, Text, TextField } from '@approvalmax/ui/src/components';
import { zodResolver } from '@hookform/resolvers/zod';
import { memo } from 'react';
import { useForm } from 'react-hook-form';
import { useCreateEmailChangeSupportTicket } from 'shared/data/webApp/v2';
import { z } from 'zod';

import { messages } from './EmailChangeViaSupportPopup.messages';
import { schema } from './EmailChangeViaSupportPopup.schema';
import { EmailChangeViaSupportPopupProps } from './EmailChangeViaSupportPopup.types';

export const EmailChangeViaSupportPopup = memo<EmailChangeViaSupportPopupProps>((props) => {
    const { open, onClose, onNext } = props;

    const form = useForm<z.infer<typeof schema>>({
        defaultValues: {
            email: '',
        },
        resolver: zodResolver(schema),
    });

    const { mutate, isLoading } = useCreateEmailChangeSupportTicket({
        onSuccess: () => {
            onNext();
        },
    });

    const formSubmit = form.handleSubmit((data) => {
        const targetEmail = data.email;

        mutate({ body: { targetEmail } });
    });

    return (
        <Popup open={open} onClose={onClose} size='xsmall' preventAutoClose>
            <Form form={form} onSubmit={formSubmit}>
                <Popup.Header
                    title={messages.title}
                    actionsSize='small'
                    progress={isLoading}
                    actions={
                        <Button type='submit' variant='text' color='blue100' size='small' progress={isLoading}>
                            {messages.buttonSend}
                        </Button>
                    }
                />

                <Popup.Body>
                    <Spacing height={4} />

                    <Flex direction='column' spacing='24'>
                        <Flex direction='column' spacing='8'>
                            <Text font='body' fontSize='small' fontWeight='medium'>
                                {messages.subtitle}
                            </Text>

                            <Text font='body' fontSize='small' fontWeight='regular'>
                                {messages.description}
                            </Text>
                        </Flex>

                        <Flex direction='column' spacing='16'>
                            <TextField
                                name='email'
                                type='email'
                                label={messages.fieldEmailLabel}
                                placeholder={messages.fieldEmailPlaceholder}
                                size='small'
                                required
                                disabled={isLoading}
                            />
                        </Flex>
                    </Flex>
                </Popup.Body>
            </Form>
        </Popup>
    );
});

EmailChangeViaSupportPopup.displayName = 'EmailChangeViaSupportPopup';
